module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-3-img-sp@2x_f2f97362fbfaf6e90f698adf96fff12f.png";